import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ConsetDBAsContext = createContext({})
const useConsentDBAsContext = () => useContext(ConsetDBAsContext)

function useContextState() {
  const [open, setOpen] = useState(false)
  const [definitions, setDefinitions] = useState({})

  const toggle = useCallback(() => {
    setOpen(open => !open)
  }, [])

  return useMemo(() => ({
    definitions, setDefinitions,
    modal: {
      open,
      toggle,
    },
  }), [open, toggle, definitions])
}

const ConsentDBAsContextProvider = ({ children }) => {
  const state = useContextState()

  return <>
    <ConsetDBAsContext.Provider value={state}>
      {children}
    </ConsetDBAsContext.Provider>
  </>
}

export {
  ConsentDBAsContextProvider,
  useConsentDBAsContext,
}
